import { Component, Input, Optional, Output, EventEmitter } from '@angular/core';
import {
  useProgressBar,
  ProgressbarProps,
  ProgressbarValue,
} from '../ad-progressbar.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AdMessageApi, ProgressBarRef } from '../adMessageConfig';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';


@UntilDestroy()
@Component({
  selector: 'ad-progressbar',
  templateUrl: './ad-progressbar-modal.component.html',
  styleUrls: ['./ad-progressbar-modal.component.scss'],
})
export class AdProgressbarComponent implements Omit<ProgressbarValue, 'mode'> {
  @Input() config: ProgressbarProps;
  @Input() title: string = '';
  @Input() closable: boolean = false;

  @Output() onRef: EventEmitter<ProgressBarRef> = new EventEmitter<ProgressBarRef>();

  value$: Observable<number>;
  completed$: Observable<boolean>;
  showValue: boolean;
  style: any;
  styleClass: string;
  unit: string;
  mode: string;
  updateValue: (number: number) => void;
  completOneTask: () => void;

  constructor(
    @Optional() private api: AdMessageApi
  ) { }

  ngOnDestroy() { }

  ngOnInit() {
    const progressBarValue = useProgressBar(
      this.config
    );
    Object.assign(this, progressBarValue);
    this.value$ = this.value$.pipe(
      tap((val) => {
        if (val >= 100) {
          setTimeout(() => {
            this.api?.closeAdMessage();
          });
        }
      })
    );
    this.completed$.pipe(untilDestroyed(this)).subscribe((param) => {
      if (param) {
        this.onClose();
      }
    });
  }

  ngAfterViewInit() {
    this.onRef.emit({
      updateValue: (number: number) => this.updateValue(number),
      completeOneTask: () => this.completOneTask(),
    })
  }

  onClose() {
    this.api?.closeAdMessage();
  }
}
